import React from 'react';
import { Box, Typography, Divider, Button } from '@mui/material';
import DashboardIcon from '@mui/icons-material/Dashboard';
import FeedbackIcon from '@mui/icons-material/Feedback';
import AssessmentIcon from '@mui/icons-material/Assessment';
import PeopleIcon from '@mui/icons-material/People';
import LogoutIcon from '@mui/icons-material/Logout';
import { themeColors } from '../common/constants';

// Add handleLogout to the props
const SideNavigation = ({ tabValue, setTabValue, handleLogout }) => (
  <Box sx={{ 
    width: 240, 
    height: '100vh', 
    position: 'fixed', 
    left: 0, 
    top: 0, 
    bgcolor: themeColors.primary, 
    color: 'white',
    display: 'flex',
    flexDirection: 'column',
    p: 2
  }}>
    <Box sx={{ display: 'flex', alignItems: 'center', mb: 4, mt: 2 }}>
      <Typography variant="h6" sx={{ fontWeight: 'bold', ml: 1 }}>CSM Admin Dashboard</Typography>
    </Box>
    
    <Divider sx={{ bgcolor: 'rgba(255, 255, 255, 0.2)', mb: 2 }} />
    
    <Box sx={{ display: 'flex', flexDirection: 'column', flex: 1 }}>
      <Button 
        startIcon={<DashboardIcon />} 
        sx={{ 
          color: 'white', 
          justifyContent: 'flex-start', 
          p: 1.5,
          mb: 0.5,
          borderRadius: 1,
          bgcolor: tabValue === 0 ? 'rgba(255, 255, 255, 0.1)' : 'transparent',
          '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.2)' }
        }}
        onClick={() => setTabValue(0)}
      >
        Dashboard
      </Button>
      
      <Button 
        startIcon={<FeedbackIcon />} 
        sx={{ 
          color: 'white', 
          justifyContent: 'flex-start', 
          p: 1.5,
          mb: 0.5,
          borderRadius: 1,
          bgcolor: tabValue === 1 ? 'rgba(255, 255, 255, 0.1)' : 'transparent',
          '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.2)' }
        }}
        onClick={() => setTabValue(1)}
      >
        Feedback Responses
      </Button>
      
      <Button 
        startIcon={<AssessmentIcon />} 
        sx={{ 
          color: 'white', 
          justifyContent: 'flex-start', 
          p: 1.5,
          mb: 0.5,
          borderRadius: 1,
          bgcolor: tabValue === 2 ? 'rgba(255, 255, 255, 0.1)' : 'transparent',
          '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.2)' }
        }}
        onClick={() => setTabValue(2)}
      >
        Reports & Analytics
      </Button>
      
      <Button 
        startIcon={<PeopleIcon />} 
        sx={{ 
          color: 'white', 
          justifyContent: 'flex-start', 
          p: 1.5,
          mb: 0.5,
          borderRadius: 1,
          bgcolor: tabValue === 3 ? 'rgba(255, 255, 255, 0.1)' : 'transparent',
          '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.2)' }
        }}
        onClick={() => setTabValue(3)}
      >
        User Management
      </Button>

    {/*   <Button 
        startIcon={<AssessmentIcon />} 
        sx={{ 
          color: 'white', 
          justifyContent: 'flex-start', 
          p: 1.5,
          mb: 0.5,
          borderRadius: 1,
          bgcolor: tabValue === 5 ? 'rgba(255, 255, 255, 0.1)' : 'transparent',
          '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.2)' }
        }}
        onClick={() => setTabValue(5)}
      >
        Yearly Report
      </Button> */}
      
    </Box>
    
    <Divider sx={{ bgcolor: 'rgba(255, 255, 255, 0.2)', mt: 2, mb: 2 }} />
    
    <Button 
      startIcon={<LogoutIcon />} 
      onClick={handleLogout}
      sx={{ 
        color: 'white', 
        justifyContent: 'flex-start', 
        p: 1.5,
        borderRadius: 1,
        '&:hover': { bgcolor: 'rgba(255, 255, 255, 0.2)' }
      }}
    >
      Logout
    </Button>
  </Box>
);

export default SideNavigation;